module.exports = __webpack_public_path__ + "img/payment-card.5fb95af5.svg";